// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"492b8afe","100":"25e43f15","253":"158eabad","268":"428089a1","302":"76de9483","355":"7032c776","395":"0084df7d","613":"f75b4370","802":"86a06249","877":"2059d8b4","895":"4413194b","927":"fa07b7d2","970":"79135301"}[chunkId] + ".chunk.js";
};